<div class="guest-modal">
  @if (!data.user.frontUserId) {
    <form [formGroup]="form1" class="form">
      <div class="info">
        <mat-form-field class="form-fields">
          <input matInput placeholder="{{'user.firstName' | translate}}" formControlName="firstName" type="text" required>
          @if (f.firstName.invalid) {
            <mat-error>
              {{'required' | translate}}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-fields">
          <input matInput placeholder="{{'user.lastName' | translate}}" formControlName="lastName" type="text" required>
          @if (f.lastName.invalid) {
            <mat-error>
              {{'required' | translate}}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-fields">
          <mat-select placeholder="{{'user.gender' | translate}}" formControlName="gender" required style="color: black">
            <mat-option [value]="'male'" style="color: black">
              {{'dashboard.male' | translate}}
            </mat-option>
            <mat-option [value]="'female'">
              {{'dashboard.female' | translate}}
            </mat-option>
            <mat-option [value]="'diverse'">
              {{'dashboard.diverse' | translate}}
            </mat-option>
          </mat-select>
          @if (f.gender.invalid) {
            <mat-error>
              {{'required' | translate}}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div class="more-info">
        <div class="info">
          <mat-form-field class="form-fields street">
            <input matInput placeholder="{{'user.street' | translate}}" formControlName="street" required>
            @if (f.street.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-fields number">
            <input matInput placeholder="{{'user.number' | translate}}" formControlName="number" required>
            @if (f.number.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-fields">
            <mat-select placeholder="{{'orgName' | translate}}" formControlName="bookedFromOrgId" required style="color: black">
              @for (org of eventOrganization; track org.id) {
                <mat-option [value]="org.id" style="color: black">
                  {{org.name}}
                </mat-option>
              }
            </mat-select>
            @if (f.orgName.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-fields">
            <input matInput placeholder="{{'orgName_old' | translate}}" formControlName="orgName">
            @if (f.orgName.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-fields">
            <input matInput placeholder="{{'postCode' | translate}}" formControlName="postcode" required>
            @if (f.postcode.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
          <mat-form-field class="form-fields">
            <input matInput placeholder="{{'user.city' | translate}}" formControlName="cityName">
            @if (f.cityName.invalid) {
              <mat-error>
                {{'required' | translate}}
              </mat-error>
            }
          </mat-form-field>
        </div>
        <div class='groupRegistration'>
          <mat-checkbox formControlName="groupRegistration">{{'group_registration' | translate}}</mat-checkbox>
          @if (showGroupRegistration) {
            <div>
              <mat-form-field class="form-fields">
                <input matInput placeholder="{{'nameOfOrganization' | translate}}" formControlName="nameOfOrganization" required>
                @if (f.nameOfOrganization.invalid) {
                  <mat-error>
                    {{'required' | translate}}
                  </mat-error>
                }
              </mat-form-field>
              <mat-form-field class="form-fields">
                <input matInput placeholder="{{'numberOfPeople' | translate}}" formControlName="numberOfPeople" type='number'
                  min="1" max="10000" required>
                  @if (f.numberOfPeople.invalid) {
                    <mat-error>
                      {{'required' | translate}}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            }
          </div>
        </div>
      </form>
    }
    <form [formGroup]="settingForm" class="form">
      <div class="manager-settings">
        @if (allGuestSettings?.personal_data) {
          <div class="titles">{{'guestModal.personal_data' | translate}}</div>
        }
        @if (allGuestSettings?.personal_data) {
          <div class="title-comment">{{titleComments?.personal_data}}</div>
        }
        @if (allGuestSettings?.personal_data) {
          <div class="settings-grid">
            @if (allGuestSettings?.personal_data?.passport) {
              <div>
                <mat-form-field class="form-fields" >
                  <input formControlName="passport" matInput placeholder="{{'guestModal.passport' | translate}}" [required]="isRequiredField('passport')">
                  <mat-error>
                    {{'required' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>
            }
            @if (allGuestSettings?.personal_data?.passport) {
              <div>
                <mat-form-field class="form-fields web-datepicker">
                  <input matInput [matDatepicker]="dp3"
                    [(ngModel)]="expiry_date" [ngModelOptions]="{standalone: true}"
                    placeholder="{{'guestModal.expiry_date' | translate}}" [required]="isRequiredField('passport')" [disabled]="true" readonly>
                    <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                    <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                  </mat-form-field>
                </div>
              }
              @if (allGuestSettings?.personal_data?.birth_place) {
                <div>
                  <mat-form-field class="form-fields">
                    <input formControlName="birth_place" matInput placeholder="{{'guestModal.birth_place' | translate}}" [required]="isRequiredField('birth_place')">
                    <mat-error>
                      {{'required' | translate}}
                    </mat-error>
                  </mat-form-field>
                </div>
              }
              @if (allGuestSettings?.personal_data?.birth_date) {
                <div>
                  <mat-form-field class="form-fields web-datepicker">
                    <input matInput [matDatepicker]="dp2" placeholder="{{'guestModal.birth_date' | translate}}"
                      formControlName="birth_date" [disabled]="true" readonly [required]="isRequiredField('birth_date')">
                      <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                      <mat-datepicker #dp2 disabled="false"></mat-datepicker>
                      @if (fs.birth_date.invalid) {
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                }
                @if (allGuestSettings?.personal_data?.mobile) {
                  <div>
                    <mat-form-field class="form-fields">
                      <input formControlName="mobile" matInput placeholder="{{'guestModal.mobile' | translate}}"
                        [required]="isRequiredField('mobile')" appPhoneMask>
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                      @if (mobileError) {
                        <div class="error">{{'correct_mobile' | translate}}</div>
                      }
                    </div>
                  }
                  @if (allGuestSettings?.personal_data?.j_s) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="j_s" matInput placeholder="{{'guestModal.j_s' | translate}}" [required]="isRequiredField('j_s')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                </div>
              }
              @if (allGuestSettings?.parent_contact) {
                <div class="titles">{{'guestModal.parent_contact' | translate}}</div>
              }
              @if (allGuestSettings?.parent_contact) {
                <div class="title-comment">{{titleComments?.parent_contact}}</div>
              }
              @if (allGuestSettings?.parent_contact) {
                <div class="settings-grid">
                  @if (allGuestSettings?.parent_contact?.siblings_number) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="siblings_number" matInput placeholder="{{'guestModal.siblings_number' | translate}}" [required]="isRequiredField('siblings_number')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.siblings_name) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="siblings_name" matInput placeholder="{{'guestModal.siblings_name' | translate}}" [required]="isRequiredField('siblings_name')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.siblings_year) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="siblings_year" matInput placeholder="{{'guestModal.siblings_year' | translate}}" [required]="isRequiredField('siblings_year')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.mother_name) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="mother_name" matInput placeholder="{{'guestModal.mother_name' | translate}}" [required]="isRequiredField('mother_name')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.mother_address) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="mother_address" matInput placeholder="{{'guestModal.mother_address' | translate}}" [required]="isRequiredField('mother_address')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.mother_email) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="mother_email" matInput placeholder="{{'guestModal.mother_email' | translate}}" [required]="isRequiredField('mother_email')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.father_name) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="father_name" matInput placeholder="{{'guestModal.father_name' | translate}}" [required]="isRequiredField('father_name')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.father_address) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="father_address" matInput placeholder="{{'guestModal.father_address' | translate}}" [required]="isRequiredField('father_address')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.father_email) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input  formControlName="father_email" matInput placeholder="{{'guestModal.father_email' | translate}}" [required]="isRequiredField('father_email')">
                        <mat-error>
                          {{'required' | translate}}
                        </mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (allGuestSettings?.parent_contact?.parents_mobile) {
                    <div>
                      <mat-form-field class="form-fields">
                        <input formControlName="parents_mobile" matInput placeholder="{{'guestModal.parents_mobile' | translate}}"
                          [required]="isRequiredField('parents_mobile')" appPhoneMask>
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (allGuestSettings?.parent_contact?.assistent_driving) {
                      <div style="width: 100%; margin: 15px 0">
                        <div style="margin-bottom: 15px;">{{'guestModal.assistent_driving' | translate}}:</div>
                        <mat-radio-group formControlName="assistent_driving" >
                          <mat-radio-button value="Ja">{{'event.yes' | translate}} </mat-radio-button>
                          <mat-radio-button value="Nein">{{'event.no' | translate}} </mat-radio-button>
                          <mat-radio-button value="nach Rücksprache">{{'after_consultation' | translate}} </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    }
                  </div>
                }
                @if (allGuestSettings?.collaboration) {
                  <div class="titles">{{'guestModal.collaboration' | translate}}</div>
                }
                @if (allGuestSettings?.collaboration) {
                  <div class="title-comment">{{titleComments?.collaboration}}</div>
                }
                @if (allGuestSettings?.collaboration) {
                  <div class="settings-grid">
                    @if (allGuestSettings?.collaboration?.signing_up_as) {
                      <div style="width: 100%; margin: 15px 0">
                        <div style="margin-bottom: 15px;">{{'signing' | translate}}</div>
                        <mat-radio-group formControlName="signing_up_as" style="display: flex; flex-direction: column;">
                          <mat-radio-button value="Teilnehmende">{{'event.participants' | translate}} </mat-radio-button>
                          <mat-radio-button value="JungleiterIn">{{'young_leader' | translate}} </mat-radio-button>
                          <mat-radio-button value="LeiterIn">{{'leader' | translate}} </mat-radio-button>
                          <mat-radio-button value="Andere">{{'other' | translate}} </mat-radio-button>
                        </mat-radio-group>
                      </div>
                    }
                    @if (allGuestSettings?.collaboration?.already_courses) {
                      <div>
                        <mat-form-field class="form-fields">
                          <input formControlName="already_courses" matInput placeholder="{{'guestModal.already_courses' | translate}}" [required]="isRequiredField('already_courses')">
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (allGuestSettings?.collaboration?.alread_firststeps) {
                      <div>
                        <mat-form-field class="form-fields">
                          <input formControlName="alread_firststeps" matInput placeholder="{{'guestModal.alread_firststeps' | translate}}" [required]="isRequiredField('alread_firststeps')">
                          <mat-error>
                            {{'required' | translate}}
                          </mat-error>
                        </mat-form-field>
                      </div>
                    }
                    @if (allGuestSettings?.collaboration?.leadership_exp) {
                      <div style="width: 100%">
                        <mat-checkbox formControlName="leadership_exp">{{'guestModal.leadership_exp'| translate}}</mat-checkbox>
                      </div>
                    }
                  </div>
                }
              </div>
            </form>

            <div class="button">
              <button type="submit" class="login-button" (click)="confirm()">{{'main.save' | translate}}</button>
            </div>

          </div>
